export const FINANCIAL_FIELD_ALIASES = Object.freeze({
  tax: ['tax', 'glovoTax'],
  rent: ['rent', 'renta'],
  petrol: ['petrol', 'gorivo'],
  acom: ['acom', 'appKnjig'],
  utility: ['utility', 'struja'],
  sim: ['sim', 'doprinosi'],
  advance: ['advance', 'akontacija'],
  bonus: ['bonus'],
  ostalo: ['ostalo'],
  fee: ['fee'],
});

const LEGACY_WRITE_MAP = Object.freeze({
  tax: 'glovoTax',
  rent: 'renta',
  petrol: 'gorivo',
  acom: 'appKnjig',
  utility: 'struja',
  sim: 'doprinosi',
  advance: 'akontacija',
});

export function toNumber(v) {
  if (typeof v === 'number') {
    return Number.isFinite(v) && !Number.isNaN(v) ? v : 0;
  }

  let s = String(v ?? '')
    .trim()
    .replace(/\u00A0/g, '')
    .replace(/\s+/g, '')
    .replace('−', '-');

  if (!s || s === '-') return 0;
  s = s.replace(/[^0-9,.-]/g, '');
  if (!s || s === '-') return 0;

  const commaCount = (s.match(/,/g) || []).length;
  const dotCount = (s.match(/\./g) || []).length;
  let normalized = s;

  if (commaCount > 0 && dotCount > 0) {
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    const decimalSep = lastComma > lastDot ? ',' : '.';
    const thousandSep = decimalSep === ',' ? '.' : ',';
    normalized = s.split(thousandSep).join('');
    if (decimalSep === ',') normalized = normalized.replace(',', '.');
  } else if (commaCount > 0 || dotCount > 0) {
    const sep = commaCount > 0 ? ',' : '.';
    const sepCount = sep === ',' ? commaCount : dotCount;

    if (sepCount > 1) {
      // Više istih separatora -> vrlo vjerojatno tisućice
      normalized = s.split(sep).join('');
    } else {
      const idx = s.lastIndexOf(sep);
      const left = s.slice(0, idx);
      const right = s.slice(idx + 1);
      const thousandsLike = right.length === 3 && /^\d+$/.test(left.replace('-', '')) && /^\d+$/.test(right);
      if (thousandsLike) {
        normalized = s.replace(sep, '');
      } else {
        normalized = sep === ',' ? s.replace(',', '.') : s;
      }
    }
  }

  const n = parseFloat(normalized);
  if (!Number.isFinite(n) || Number.isNaN(n)) return 0;
  return n;
}

/** Zaokruži novčani iznos na 2 decimale (Excel / obračun). */
export function roundMoney(v) {
  const n = toNumber(v);
  return Math.round((n + Number.EPSILON) * 100) / 100;
}

export function getFinancialValue(source, canonicalKey) {
  const aliases = FINANCIAL_FIELD_ALIASES[canonicalKey] || [canonicalKey];
  for (const key of aliases) {
    if (source?.[key] !== undefined && source?.[key] !== null && source?.[key] !== '') {
      return toNumber(source[key]);
    }
  }
  return 0;
}

export function getCanonicalFinancials(source) {
  return {
    tax: getFinancialValue(source, 'tax'),
    rent: getFinancialValue(source, 'rent'),
    petrol: getFinancialValue(source, 'petrol'),
    acom: getFinancialValue(source, 'acom'),
    utility: getFinancialValue(source, 'utility'),
    sim: getFinancialValue(source, 'sim'),
    advance: getFinancialValue(source, 'advance'),
    bonus: getFinancialValue(source, 'bonus'),
    ostalo: getFinancialValue(source, 'ostalo'),
    fee: getFinancialValue(source, 'fee'),
  };
}

export function addLegacyFinancialAliases(payload = {}) {
  const out = { ...payload };
  Object.entries(LEGACY_WRITE_MAP).forEach(([newKey, oldKey]) => {
    if (out[newKey] !== undefined) out[oldKey] = out[newKey];
    if (out[oldKey] !== undefined && out[newKey] === undefined) out[newKey] = out[oldKey];
  });
  return out;
}

export function getFinancialMigrationPatch(data = {}) {
  const patch = {};
  Object.entries(LEGACY_WRITE_MAP).forEach(([newKey, oldKey]) => {
    const hasNew = data[newKey] !== undefined;
    const hasOld = data[oldKey] !== undefined;
    if (!hasNew && hasOld) patch[newKey] = toNumber(data[oldKey]);
    if (hasNew && !hasOld) patch[oldKey] = toNumber(data[newKey]);
  });
  return patch;
}

